import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';


export default function KeySmart(props) {
  return (
    <SvgIcon {...props}>
      <g>
        <path
          d="M0 3.39041C0.449522 3.39041 0.89305 3.39041 1.37853 3.39041C1.37853 5.00434 1.37853 6.60086
          1.37853 8.26124C1.53437 8.17415 1.63626 8.1219 1.72616 8.06385C4.14159 6.56022 6.55103 5.05659
          8.97245 3.55877C9.13428 3.46008 9.35604 3.40202 9.55383 3.39622C10.2311 3.3788 10.9084 3.39041
          11.6156 3.44846C9.38002 4.84179 7.1444 6.24092 4.86682 7.66327C7.15039 9.4862 9.398 11.2743
          11.6456 13.0682C11.6396 13.0914 11.6336 13.1146 11.6276 13.1379C11.1841 13.1379 10.7406 13.1088
          10.297 13.1437C9.81755 13.1785 9.45194 13.0392 9.08633 12.7373C7.37815 11.344 5.64599 9.97967
          3.93182 8.59796C3.73403 8.4354 3.59617 8.40637 3.36842 8.55732C2.823 8.92887 2.2596 9.2772
          1.6902 9.61973C1.47443 9.74745 1.37853 9.89259 1.38453 10.1538C1.40251 11.0305 1.39052 11.9071
          1.39052 12.7837C1.39052 12.8882 1.39052 12.9927 1.39052 13.1669C0.905037 13.1669 0.449522 13.1669
          0 13.1669C0 9.9042 0 6.6473 0 3.39041Z"
          fill="currentColor"
        />
        <path
          d="M39.2402 16C39.2462 15.8549 39.2522 15.7097 39.2522 15.5646C39.2522 10.4964 39.2522 5.42816 39.2522
          0.359942C39.2522 0.243832 39.2522 0.133527 39.2522 0C39.5279 0 39.7797 0 40.0554 0C40.0614 0.0638607
          40.0793 0.121916 40.0793 0.185776C40.0793 5.45718 40.0793 10.7286 40.0793 15.9942C39.7976 16 39.5159
          16 39.2402 16Z"
          fill="currentColor"
        />
        <path
          d="M68.2314 13.1379C68.2314 10.7692 68.2314 8.44123 68.2314 6.03194C68.1415 6.14225 68.0995 6.18869
          68.0696 6.24094C66.709 8.44123 65.3425 10.6415 63.9939 12.8418C63.862 13.0624 63.7122 13.1263 63.4545
          13.1495C62.993 13.1901 62.7532 13.016 62.5195 12.6328C61.2428 10.5196 59.9302 8.42382 58.6296
          6.32222C58.5877 6.25255 58.5337 6.18869 58.4138 6.13644C58.4138 6.24675 58.4138 6.35705 58.4138
          6.46736C58.4138 8.56895 58.4078 10.6706 58.4198 12.7721C58.4198 13.0682 58.3419 13.1727 58.0362
          13.1437C57.7965 13.1205 57.5568 13.1263 57.317 13.1437C57.0833 13.1611 57.0293 13.0682 57.0293
          12.8592C57.0353 11.6459 57.0353 10.4325 57.0353 9.21337C57.0353 7.40785 57.0353 5.60814 57.0353
          3.80263C57.0353 3.68071 57.0353 3.55299 57.0353 3.39044C57.4788 3.39044 57.8984 3.37882 58.306
          3.40205C58.3899 3.40785 58.4798 3.54138 58.5397 3.63427C60.0681 6.09581 61.5965 8.56315 63.1188
          11.0247C63.1728 11.1118 63.2327 11.1989 63.3166 11.3324C63.6163 10.8505 63.892 10.4093 64.1677
          9.96808C65.4683 7.86068 66.7749 5.74747 68.0696 3.63427C68.1774 3.4543 68.2913 3.36721 68.5191
          3.38463C68.7888 3.40205 69.0585 3.40205 69.3282 3.38463C69.544 3.37302 69.5979 3.4601 69.5979
          3.65168C69.5859 4.13354 69.5919 4.6154 69.5919 5.09726C69.5919 7.66329 69.5859 10.2235 69.5979
          12.7896C69.5979 13.074 69.514 13.1611 69.2263 13.1379C68.9147 13.1205 68.585 13.1379 68.2314
          13.1379Z"
          fill="currentColor"
        />
        <path
          d="M94.9449 8.31354C94.9689 8.34837 94.9749 8.38321 94.9929 8.39482C95.868 8.94634 96.1017 9.79395
          96.1197 10.7228C96.1317 11.4369 96.1197 12.151 96.1317 12.8651C96.1317 13.0566 96.0897 13.1495 95.8679
          13.1379C95.5083 13.1263 95.1547 13.1321 94.7591 13.1321C94.7531 13.0102 94.7411 12.9115 94.7411
          12.8128C94.7411 12.1394 94.7531 11.4659 94.7411 10.7867C94.7352 10.5312 94.6992 10.2642 94.6393
          10.0146C94.5553 9.64881 94.3036 9.38756 93.932 9.29467C93.4825 9.18437 93.015 9.06826 92.5535
          9.06245C91.0551 9.03343 89.5567 9.04504 88.0643 9.04504C88.0043 9.04504 87.9504 9.05665 87.8545
          9.06245C87.8545 9.19017 87.8545 9.30048 87.8545 9.41078C87.8545 10.5603 87.8485 11.704 87.8605
          12.8535C87.8605 13.0625 87.8125 13.1495 87.5788 13.1379C87.2252 13.1205 86.8656 13.1321 86.482
          13.1321C86.482 9.87522 86.482 6.64155 86.482 3.38466C86.5958 3.38466 86.6917 3.38466 86.7876
          3.38466C88.5438 3.38466 90.2999 3.37885 92.056 3.38466C92.8771 3.38466 93.6863 3.46594 94.4714
          3.72719C96.4613 4.38901 96.8269 6.92602 95.1727 8.12777C95.1008 8.19163 95.0228 8.24968 94.9449
          8.31354ZM90.3418 4.70832C90.3418 4.6909 90.3418 4.67348 90.3418 4.65607C89.6106 4.65607 88.8854
          4.66187 88.1542 4.65026C87.9444 4.65026 87.8485 4.6909 87.8545 4.92312C87.8665 5.78814 87.8605
          6.65897 87.8545 7.52399C87.8545 7.70396 87.9084 7.77943 88.1062 7.77943C89.4728 7.77363 90.8393
          7.78524 92.2059 7.76782C92.9011 7.75621 93.5724 7.6343 94.1778 7.26855C94.6812 6.96666 94.891
          6.53705 94.8311 5.97392C94.7771 5.45723 94.4595 5.12631 93.98 4.95215C93.6563 4.83604 93.3087
          4.73154 92.967 4.71993C92.098 4.6851 91.2169 4.70832 90.3418 4.70832Z"
          fill="currentColor"
        />
        <path
          d="M22.2124 4.656C22.0565 4.656 21.9307 4.656 21.7988 4.656C19.4253 4.656 17.0459 4.6618 14.6724
          4.65019C14.3907 4.65019 14.2888 4.71986 14.3008 5.00433C14.3188 5.7068 14.3188 6.40926 14.3008
          7.11753C14.2948 7.37298 14.3727 7.44845 14.6364 7.44845C16.884 7.43684 19.1257 7.44264 21.3733
          7.44264C21.7569 7.44264 21.7569 7.44264 21.7569 7.82C21.7569 8.10447 21.7569 8.39475 21.7569
          8.72566C20.4982 8.72566 19.2635 8.72566 18.0288 8.72566C16.8061 8.72566 15.5774 8.72566 14.3427
          8.72566C14.3248 8.79533 14.3068 8.84177 14.3068 8.88822C14.3068 9.79388 14.3128 10.6995 14.3008
          11.6052C14.2948 11.8664 14.4566 11.8432 14.6304 11.8432C17.0459 11.8432 19.4613 11.8432 21.8767
          11.8432C22.0026 11.8432 22.1345 11.8432 22.3083 11.8432C22.3083 12.2496 22.3143 12.627 22.3023
          13.0101C22.3023 13.0508 22.2244 13.1088 22.1704 13.1262C22.0985 13.1495 22.0146 13.1379 21.9307
          13.1379C19.0537 13.1379 16.1828 13.132 13.3058 13.1437C13.0062 13.1437 12.9163 13.0798 12.9163
          12.7779C12.9282 9.77066 12.9282 6.7634 12.9163 3.75614C12.9163 3.47748 12.9762 3.37878 13.2939
          3.37878C16.1468 3.3904 19.0058 3.38459 21.8587 3.38459C21.9666 3.38459 22.0745 3.38459 22.2064
          3.38459C22.2124 3.8142 22.2124 4.20897 22.2124 4.656Z"
          fill="currentColor"
        />
        <path
          d="M43.8433 9.31201C44.2449 9.31201 44.6525 9.3062 45.06 9.31782C45.114 9.31782 45.1739 9.4049
          45.2099 9.46295C45.2339 9.5094 45.2279 9.57326 45.2339 9.63131C45.2818 10.7111 45.8632 11.431
          46.9061 11.7561C48.5004 12.2496 50.1067 12.2438 51.683 11.6516C51.9227 11.5646 52.1505 11.4252
          52.3423 11.2627C52.9836 10.7286 52.8757 9.82289 52.0906 9.5152C51.4013 9.24234 50.6761 9.05076
          49.9448 8.89401C48.6922 8.62696 47.4215 8.41215 46.1629 8.17413C46.0969 8.16252 46.031 8.13349
          45.9651 8.11607C45.066 7.85483 44.4247 7.34394 44.2689 6.40345C44.0951 5.35845 44.5026 4.55729
          45.4137 3.98835C46.1329 3.54133 46.942 3.33233 47.7811 3.25105C48.9379 3.14075 50.0947 3.14075
          51.2275 3.44263C52.606 3.81419 53.4032 4.70243 53.6849 6.0377C53.7328 6.2525 53.7628 6.47311
          53.8107 6.73436C53.3612 6.73436 52.9476 6.74017 52.5341 6.72855C52.4861 6.72855 52.4142 6.61825
          52.3962 6.54858C52.3483 6.38022 52.3303 6.20606 52.2824 6.0435C52.0666 5.3004 51.5631 4.81854
          50.7959 4.64437C49.4414 4.33668 48.0868 4.33088 46.7562 4.78951C46.4865 4.8824 46.2228 5.02173
          46.007 5.2017C45.3837 5.71839 45.5156 6.58922 46.2827 6.85628C46.9181 7.07689 47.5893 7.193
          48.2546 7.32072C49.6691 7.59938 51.1196 7.74452 52.4682 8.27863C53.8287 8.81274 54.4281 10.0667
          53.9246 11.3033C53.6849 11.8955 53.2234 12.3019 52.66 12.6037C51.9347 12.9927 51.1436 13.2017
          50.3224 13.2714C48.872 13.4049 47.4275 13.3759 46.055 12.8185C44.4607 12.1741 43.7834 10.8447
          43.8433 9.31201Z"
          fill="currentColor"
        />
        <path
          d="M71.8635 13.1379C71.9354 12.9986 71.9774 12.9057 72.0313 12.8128C73.7815 9.75331 75.5316 6.6938
          77.2698 3.6343C77.3777 3.44852 77.5035 3.40788 77.7133 3.37885C78.2887 3.29758 78.5764 3.52399
          78.8521 4.02327C80.4584 6.97827 82.1126 9.91586 83.7429 12.8593C83.7848 12.9347 83.8148 13.0102
          83.8747 13.1379C83.3653 13.1379 82.9038 13.1495 82.4363 13.1263C82.3524 13.1205 82.2565 12.9928
          82.2025 12.8999C81.753 12.1162 81.3095 11.3324 80.8779 10.5371C80.776 10.3513 80.6562 10.2816
          80.4344 10.2816C78.7382 10.2874 77.042 10.2874 75.3458 10.2816C75.136 10.2816 75.0222 10.3513
          74.9263 10.5254C74.4827 11.3208 74.0212 12.1103 73.5777 12.9057C73.4818 13.0857 73.3619 13.1553
          73.1581 13.1437C72.7446 13.1263 72.331 13.1379 71.8635 13.1379ZM75.7953 8.96957C77.2218 8.96957
          78.5884 8.96957 80.0029 8.96957C79.3136 7.70396 78.6483 6.479 77.9471 5.18437C77.2158 6.46739
          76.5206 7.69235 75.7953 8.96957Z"
          fill="currentColor"
        />
        <path
          d="M23.2193 3.3905C23.8546 3.3905 24.406 3.37309 24.9515 3.40211C25.0833 3.40792 25.2272 3.53564
          25.3291 3.64014C26.6716 4.99863 28.0082 6.36873 29.3448 7.73303C29.4047 7.79689 29.4407 7.87817
          29.4886 7.95364C29.5366 7.96525 29.5905 7.97105 29.6385 7.98267C29.6864 7.89558 29.7104 7.79108
          29.7823 7.72142C31.1309 6.35132 32.4795 4.98702 33.828 3.61692C33.9839 3.46017 34.1337 3.37309
          34.3674 3.3847C34.8469 3.40211 35.3264 3.3905 35.8718 3.3905C35.7759 3.50081 35.722 3.57047
          35.6561 3.63433C33.9359 5.39341 32.2157 7.15248 30.4836 8.89994C30.2978 9.09152 30.2199 9.2773
          30.2199 9.53854C30.2318 10.6474 30.2199 11.7563 30.2318 12.8651C30.2318 13.0741 30.1779 13.1612
          29.9441 13.1438C29.7164 13.1264 29.4826 13.1205 29.2549 13.1438C28.9612 13.1728 28.8593 13.0857
          28.8653 12.7838C28.8833 11.675 28.8653 10.5661 28.8773 9.45727C28.8773 9.24827 28.8114 9.09733
          28.6615 8.94638C26.9413 7.20473 25.2272 5.45146 23.507 3.704C23.4351 3.61692 23.3572 3.53564 23.2193
          3.3905Z"
          fill="currentColor"
        />
        <path
          d="M109 3.40778C109 3.78514 109.012 4.15089 108.988 4.51083C108.982 4.56308 108.802 4.65016 108.7
          4.65016C107.454 4.66177 106.207 4.65597 104.96 4.65597C104.541 4.65597 104.541 4.65597 104.541
          5.06816C104.541 7.64 104.535 10.2177 104.547 12.7895C104.547 13.0682 104.469 13.1669 104.181
          13.1378C103.941 13.1146 103.702 13.1204 103.462 13.1378C103.204 13.161 103.15 13.0565 103.15
          12.8243C103.156 10.7692 103.156 8.71983 103.156 6.66468C103.156 6.08413 103.15 5.50938 103.162
          4.92883C103.168 4.71402 103.09 4.64436 102.869 4.65016C101.58 4.65597 100.291 4.65016 99.0086
          4.65597C98.7749 4.65597 98.685 4.59791 98.697 4.36569C98.715 4.0522 98.703 3.73289 98.703
          3.40198C102.143 3.40778 105.548 3.40778 109 3.40778Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
}
